import {useQuery} from "react-query";
import axios from "axios";

export function useRoles() {
  const Baseurl = process.env.REACT_APP_BASEURL;
  const getToken = localStorage.getItem("eftd-admin-token");
  const tokenObject = getToken ? JSON.parse(getToken) : null;
  const token = tokenObject?.data?.data?.token;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const getAdmin = async () => {
    if (!token) {
      console.error("No authentication token found.");
      return null;
    }
    const response = await axios.get(
      `${Baseurl}/api/admin/auth/currentadmin`,
      config
    );
    return response?.data?.data;
  };

  const {data} = useQuery("CURRENT_ADMIN", getAdmin);

  const isSuperAdmin = data?.isSuperAdmin;
  const scope = data?.scope;

  return {isSuperAdmin, scope, data};
}
